var _excluded = ["property"];
var _templateObject;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import gql from 'graphql-tag';
import { EventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import { NextEvent } from '@domain-group/fe-co-allhomes-enquiry-form';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment ListingNextEvent on Property {\n    listing {\n      url\n      price\n      events {\n        startTime\n        endTime\n      }\n    }\n    address {\n      line1\n      division {\n        name\n      }\n    }\n    features {\n      bedrooms\n      bathrooms {\n        total\n      }\n      parking {\n        total\n      }\n    }\n  }\n"])));
var graphQLToProps = property => {
  if (!isEmpty(property.listing.events)) {
    return {
      inspection: {
        startDate: property.listing.events[0].startTime,
        location: {
          address: {
            addressLocality: property.address.division.name,
            streetAddress: property.address.line1,
            url: property.listing.url,
            price: property.listing.price,
            beds: property.features.bedrooms,
            baths: property.features.bathrooms.total,
            parking: property.features.parking.total
          }
        }
      }
    };
  }
  return [];
};
var NextEventGraphQL = _ref => {
  var property = _ref.property,
    props = _objectWithoutProperties(_ref, _excluded);
  return !isEmpty(graphQLToProps(property)) && ___EmotionJSX(EventBoundary, {
    name: "mobile"
  }, ___EmotionJSX(NextEvent, _extends({}, graphQLToProps(property), props)));
};
NextEventGraphQL.fragment = fragment;
NextEventGraphQL.propTypes = {
  property: PropTypes.shape({
    listing: PropTypes.shape({
      url: PropTypes.string,
      price: PropTypes.string,
      events: PropTypes.arrayOf(PropTypes.shape({
        startTime: PropTypes.string,
        endTime: PropTypes.string
      }))
    }),
    address: PropTypes.shape({
      address: PropTypes.shape({
        line1: PropTypes.string,
        division: PropTypes.shape({
          name: PropTypes.string
        })
      })
    }),
    features: PropTypes.shape({
      bedrooms: PropTypes.number,
      bathrooms: PropTypes.shape({
        total: PropTypes.number
      }),
      parking: PropTypes.shape({
        total: PropTypes.number
      }),
      keyDetails: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string
      }))
    })
  })
};
NextEventGraphQL.defaultProps = {
  property: {}
};
export default NextEventGraphQL;